import { STORAGE_KEYS } from "const";
import ExpenseService from "services/ExpenseService";

export const fetchExpenseTypes = async (setExpenseTypes) => {
  try {
    const cachedExpenseTypes = localStorage.getItem(STORAGE_KEYS.EXPENSE_TYPES);
    if (cachedExpenseTypes) {
      setExpenseTypes(JSON.parse(cachedExpenseTypes));
      return;
    }

    const data = await ExpenseService.getExpenseTypes();
    if (data && Array.isArray(data)) {
      setExpenseTypes(data);
      localStorage.setItem(STORAGE_KEYS.EXPENSE_TYPES, JSON.stringify(data));
    }
  } catch (error) {
    console.error("Failed to fetch expense types", error);
  }
};

export const syncExpenseTypes = async (setExpenseTypes) => {
  try {
    const data = await ExpenseService.getExpenseTypes();
    if (data && Array.isArray(data)) {
      if (setExpenseTypes) setExpenseTypes(data);
      localStorage.setItem(STORAGE_KEYS.EXPENSE_TYPES, JSON.stringify(data));
      return data;
    }
  } catch (error) {
    console.error("Failed to sync expense types", error);
    throw error;
  }
};

export const createExpense = async (payload) => {
  return await ExpenseService.createExpense(payload);
};
